import { FormulaSymbolToolbar } from "@/components/formula-editor/FormulaSymbolToolbar";

interface SymbolsPanelProps {
	/** Insert the chosen symbol/structure LaTeX (host wires this to the
	 *  editor — inline math at the cursor in Flow, or the focused equation). */
	onInsert: (latex: string) => void;
	/** Put this in the search field — paste-to-fix's "Look up ℵ". A new `seq`
	 *  applies it again even when the text is the same. */
	query?: { text: string; seq: number } | null;
}

/**
 * Symbols — the persistent left-rail panel (ds24 Arrangement A). Wraps the
 * existing FormulaSymbolToolbar (tabbed Greek / operators / structures grid),
 * which was previously only reachable inside the formula-editor modal. The
 * toolbar is already a pure onInsert component, so this is a thin host with a
 * testid'd root for the rail.
 */
export function SymbolsPanel({ onInsert, query }: SymbolsPanelProps) {
	return (
		<div data-testid="symbols-panel" className="h-full overflow-hidden">
			<FormulaSymbolToolbar onInsert={onInsert} query={query} />
		</div>
	);
}
